//react
import { useEffect, useState, useRef } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { Mobile, PC } from "../../media/MediaQuery";

//css
import styled from "styled-components";
// img
import minus from "../../assets/img/icon/minus.svg";
import total from "../../assets/img/icon/total.svg";

// responsive
import { M, MMinus, T } from "../../utils/MT";

export default function PaymentInfo(props) {
    //페이지 이동
    const navigate = useNavigate();
    const goDetailPage = () => {
        navigate.push(`/product/detail/:` + props.i);
    };

    return (
        <>
            {/* 타이틀 */}
            <MyPageTitleBox>
                <MyPageTitle>결제정보</MyPageTitle>
            </MyPageTitleBox>

            <OrderInfoBoxWrap>
                {/* 첫번째 박스 */}
                <OrderInfoBox>
                    <ProductPayTitle>
                        <OrderText>총 상품금액</OrderText>
                        <OrderPay>
                            9,9000,000<span>원</span>
                        </OrderPay>
                    </ProductPayTitle>

                    <OrderDetailContent>
                        <OrderDetailTitle>
                            <OrderDetailText>총 상품금액</OrderDetailText>
                            <OrderDetailPay>
                                9,9000,000<span>원</span>
                            </OrderDetailPay>
                        </OrderDetailTitle>
                        <OrderDetailTitle>
                            <OrderDetailText>배송비</OrderDetailText>
                            <OrderDetailPay>
                                0<span>원</span>
                            </OrderDetailPay>
                        </OrderDetailTitle>
                    </OrderDetailContent>
                </OrderInfoBox>

                {/* 두번째 박스 */}
                <OrderInfoBox>
                    <SailTitle>
                        <OrderText>총 할인금액</OrderText>
                        <OrderPay>
                            0<span>원</span>
                        </OrderPay>
                    </SailTitle>

                    <OrderDetailContent>
                        <OrderDetailTitle>
                            <OrderDetailText>등급할인</OrderDetailText>
                            <OrderDetailPay>
                                0<span>원</span>
                            </OrderDetailPay>
                        </OrderDetailTitle>
                        <OrderDetailTitle>
                            <OrderDetailText>쿠폰</OrderDetailText>
                            <OrderDetailPay>
                                0<span>원</span>
                            </OrderDetailPay>
                        </OrderDetailTitle>
                    </OrderDetailContent>
                </OrderInfoBox>

                {/* 두번째 박스 */}
                <OrderInfoBox>
                    <OrderTitle>
                        <OrderText>총 결제금액</OrderText>
                        <TotalPay>
                            9,900,000<span>원</span>
                        </TotalPay>
                    </OrderTitle>

                    <OrderDetailContent>
                        <OrderDetailTitle>
                            <OrderDetailText>무통장입금</OrderDetailText>
                            <OrderDetailPay>
                                9,900,000<span>원</span>
                            </OrderDetailPay>
                        </OrderDetailTitle>
                        <OrderDetailTitle>
                            <BankText>신한은행 110-1234-67898</BankText>
                        </OrderDetailTitle>
                    </OrderDetailContent>
                </OrderInfoBox>
            </OrderInfoBoxWrap>
        </>
    );
}

const MyPageTitleBox = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
`;
const MyPageTitle = styled.p`
    font-size: calc(100vw * (25 / 1920));

    @media screen and (max-width: 1300px) {
        font-size: calc(100vw * (25 / 1300));
    }

    @media screen and (max-width: 900px) {
        font-size: ${M(20)};
    }
`;

// 결제정보
const OrderInfoBoxWrap = styled.ul`
    display: flex;

    // width: calc(100vw * (840 / 1920));
    width: 100%;
    min-height: calc(100vw * (250 / 1920));
    margin-top: calc(100vw * (20 / 1920));

    border-top: 1px solid #222222;
    border-bottom: 1px solid #dddddd;

    @media screen and (max-width: 1300px) {
        min-height: calc(100vw * (250 / 1300));
        margin-top: calc(100vw * (20 / 1300));
    }

    @media screen and (max-width: 900px) {
        flex-wrap: wrap;
        min-height: auto;
        margin-top: ${M(20)};
    }
`;
const OrderInfoBox = styled.li`
    position: relative;
    width: 100%;
    // width: calc(100vw * (280 / 1920));
    height: 100%;

    &:not(:last-child) {
        border-right: 1px solid #dddddd;
    }

    @media screen and (max-width: 900px) {
        &:not(:last-child) {
            border-bottom: 1px solid #dddddd;
            border-right: none;
        }
    }
`;
const OrderTitle = styled.div`
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;

    min-height: calc(100vw * (103 / 1920));

    padding: calc(100vw * (36 / 1920)) calc(100vw * (25 / 1920));

    background: #fafafa;
    border-bottom: 1px solid #dddddd;

    @media screen and (max-width: 1300px) {
        min-height: calc(100vw * (103 / 1300));
        padding: calc(100vw * (36 / 1300)) calc(100vw * (25 / 1300));
    }

    @media screen and (max-width: 900px) {
        min-height: auto;
        padding: ${M(23)} 0;
        border-bottom: none;
        background: none;
    }
`;
const ProductPayTitle = styled(OrderTitle)`
    position: relative;

    &::after {
        position: absolute;
        top: 50%;
        right: 0;
        content: "";

        width: calc(100vw * (22 / 1920));
        height: calc(100vw * (22 / 1920));

        background: url(${minus}) no-repeat center center / contain;

        transform: translate(50%, -50%);
        z-index: 1;

        @media screen and (max-width: 1300px) {
            width: calc(100vw * (22 / 1300));
            height: calc(100vw * (22 / 1300));
        }

        @media screen and (max-width: 900px) {
            display: none;
            width: ${M(22)};
            height: ${M(22)};
        }
    }
`;
const SailTitle = styled(OrderTitle)`
    position: relative;

    &::after {
        position: absolute;
        top: 50%;
        right: 0;
        content: "";

        width: calc(100vw * (22 / 1920));
        height: calc(100vw * (22 / 1920));

        background: url(${total}) no-repeat center center / contain;

        transform: translate(50%, -50%);
        z-index: 1;

        @media screen and (max-width: 1300px) {
            width: calc(100vw * (22 / 1300));
            height: calc(100vw * (22 / 1300));
        }

        @media screen and (max-width: 900px) {
            display: none;
            width: ${M(22)};
            height: ${M(22)};
        }
    }
`;
const OrderText = styled.p`
    max-width: calc(100vw * (100 / 1920));
    font-size: calc(100vw * (15 / 1920));

    @media screen and (max-width: 1300px) {
        max-width: calc(100vw * (100 / 1300));
        font-size: calc(100vw * (15 / 1300));
    }

    @media screen and (max-width: 900px) {
        max-width: ${M(80)};
        font-family: "Noto-B";
        font-size: ${M(15)};
    }
`;
const OrderPay = styled.p`
    font-family: "Noto-B";
    max-width: calc(100% - 100vw * (100 / 1920));
    font-size: calc(100vw * (20 / 1920));
    word-break: break-word;

    & span {
        margin-left: calc(100vw * (2 / 1920));
        font-family: "Noto-R";
        font-size: calc(100vw * (13 / 1920));
    }

    @media screen and (max-width: 1300px) {
        max-width: calc(100% - 100vw * (100 / 1920));
        font-size: calc(100vw * (20 / 1300));

        & span {
            margin-left: calc(100vw * (2 / 1300));
            font-size: calc(100vw * (13 / 1300));
        }
    }

    @media screen and (max-width: 900px) {
        max-width: ${MMinus(80)};
        display: flex;
        align-items: center;
        font-size: ${M(20)};

        & span {
            font: ${M(13)} "Noto-B";
            margin-left: ${M(2)};
        }
    }
`;
const OrderDetailText = styled.p`
    font-size: calc(100vw * (13 / 1920));

    @media screen and (max-width: 1300px) {
        font-size: calc(100vw * (13 / 1300));
    }

    @media screen and (max-width: 900px) {
        font-size: ${M(13)};
    }
`;
const OrderDetailPay = styled.p`
    width: calc(100vw * (122 / 1920));
    background: red;

    display: flex;
    align-items: baseline;
    justify-content: flex-end;

    font-size: calc(100vw * (13 / 1920));

    & span {
        margin-left: calc(100vw * (2 / 1920));
        font-family: "Noto-R";
        font-size: calc(100vw * (13 / 1920));
    }

    @media screen and (max-width: 1300px) {
        width: calc(100vw * (122 / 1300));
        font-size: calc(100vw * (13 / 1300));

        & span {
            margin-left: calc(100vw * (2 / 1300));
            font-size: calc(100vw * (13 / 1300));
        }
    }

    @media screen and (max-width: 900px) {
        width: ${M(122)};
        font-size: ${M(13)};

        & span {
            font-size: ${M(13)};
            margin-left: ${M(2)};
        }
    }
`;
const OrderDetailContent = styled.div`
    padding: calc(100vw * (36 / 1920)) calc(100vw * (25 / 1920));

    @media screen and (max-width: 1300px) {
        padding: calc(100vw * (36 / 1300)) calc(100vw * (25 / 1300));
    }

    @media screen and (max-width: 900px) {
        padding: 0 0 ${M(27)};
    }
`;
const OrderDetailTitle = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;

    &:not(:first-child) {
        margin-top: calc(100vw * (10 / 1920));

        @media screen and (max-width: 1300px) {
            &:not(:first-child) {
                margin-top: calc(100vw * (10 / 1300));
            }
        }

        @media screen and (max-width: 900px) {
            &:not(:first-child) {
                margin-top: ${M(10)};
            }
        }
    }
`;
const TotalPay = styled(OrderPay)`
    color: var(--main-color);
`;
const BankText = styled(OrderDetailPay)`
    justify-content: flex-start;

    width: 100%;
    color: #aaaaaa;
`;
